var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m98.17 80 58.07-58.07c5.02-5.02 5.02-13.15 0-18.17s-13.15-5.02-18.17 0L80 61.83 21.93 3.76c-5.02-5.01-13.15-5.01-18.17 0s-5.02 13.15 0 18.17L61.83 80 3.76 138.07c-5.02 5.02-5.02 13.15 0 18.17s13.15 5.02 18.17 0L80 98.17l58.07 58.07c5.02 5.02 13.15 5.02 18.17 0s5.02-13.15 0-18.17L98.17 80Z"
})));

export default SvgClose;